import React from 'react'
import PropTypes from 'prop-types'

import Card from '../../../elements/Card'
import Avatar from '../../../elements/Avatar'
import Heading from '../../../typography/Heading'
import { formatSalary } from '../../../helpers/currencyHelpers'
import Text from '../../../typography/Text'

import OnlineProfileItem from './OnlineProfileItem'
import OnlineProfileList from './OnlineProfileList'

import styles from './styles'

const DetailsCard = ({
  trackCard,
  profilePicture,
  name,
  overallYearsExperience,
  salary,
  netherlandsPreferredAnnualSalary,
  openToPermanentWork,
  onlineProfiles,
  children,
}) => (
  <Card className={styles.wrapper} onClick={trackCard}>
    <div className={styles.details}>
      <Avatar size="large" theme="primary" url={profilePicture} />

      <div className={styles.description}>
        <Heading className={styles.name}>
          <strong>{name}</strong>
        </Heading>

        <Text className={styles.experience}>
          <strong>
            {overallYearsExperience} years exp&nbsp;
            {Boolean(openToPermanentWork) && (
              <>
                {Boolean(salary) && (
                  <>
                    | Prefers <span className={styles.salary}>{formatSalary('ZAR', salary, 'month')}</span>
                  </>
                )}
                {salary && netherlandsPreferredAnnualSalary ? <> or</> : null}
                {!salary && netherlandsPreferredAnnualSalary ? <>|</> : null}
                {Boolean(netherlandsPreferredAnnualSalary) && (
                  <>
                    {' '}
                    Prefers <span className={styles.salary}>{formatSalary('EUR', netherlandsPreferredAnnualSalary, 'year')}</span>
                  </>
                )}
              </>
            )}
          </strong>
        </Text>

        {Boolean(onlineProfiles.length > 0) && (
          <OnlineProfileList>
            {onlineProfiles.map(onlineProfile => (
              <OnlineProfileItem key={onlineProfile.name} url={onlineProfile.url} name={onlineProfile.name} />
            ))}
          </OnlineProfileList>
        )}
      </div>
    </div>

    {children}
  </Card>
)

const { string } = PropTypes
DetailsCard.propTypes = {
  trackCard: PropTypes.func,
  profilePicture: string,
  name: string,
  overallYearsExperience: string,
  salary: string,
  netherlandsPreferredAnnualSalary: string,
  openToPermanentWork: PropTypes.bool,
  onlineProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      type: string,
      url: string,
      name: string, // icon name
    }),
  ),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default DetailsCard
